<template>
  <header>
    <router-link to="/tool"><img src="@/assets/images/logo.svg" alt=""></router-link>
    <div class="user-info" v-if="type !== 'bridge' && type !== 'myinfo'" >
      <span class="user-name">{{userData.userId}},</span>
      <span class="user-plan"><p>{{planData.planName}} Plan</p> is in use.</span>
    </div>
    <div class="user-icon" v-if="type !== 'bridge'">
      <span><img src="@/assets/images/icon-user-wrap.svg" alt=""></span>
      <ul class="myinfo-list">
        <li>{{userData.userId}}</li>
<!--        <li @click="onClickMyInfo">User Info</li>-->
        <li><button-item :btnText="'Logout'" :btnClass="'logout'" @click="onSignOut"/></li>
      </ul>
    </div>
  </header>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import ButtonItem from '@/components/ui/button'

export default {
  name: 'DashboardHeader',
  components: {
    ButtonItem
  },
  props: [
    'type'
  ],
  computed: {
    ...mapState([
      'userData',
      'planData'
    ])
  },
  methods: {
    ...mapMutations([
      'clearAllUserData'
    ]),
    onSignOut () {
      this.$root.$children[0].signOut()
      this.$router.push({ name: 'sign-in' })
    },
    onClickMyInfo () {
      this.$router.push({ name: 'myinfo' })
    }
  }
}
</script>

<style lang="scss" scoped>
header {
  position: relative;
  width: 100%;
  height: 32px;
  top: 0;
  left: 0;
  &>a {
    position: absolute;
    bottom: 0;
    left: 15px;
  }
  .user-info {
    position: absolute;
    bottom: 0;
    left: 195px;
    &::after {
      content: "";
      position: absolute;
      width: 1px;
      height: 32px;
      left: -20px;
      bottom: 0;
      background: #d8d8d8;
    }
    span {
      display: inline-block;
      &.user-name {
        font-size: 14px;
        font-weight: 500;
        color: #444;
        margin-right: 10px;
      }
      &.user-plan {
        font-size: 13px;
        color: #444;
        p {
          display: inline-block;
          color: #ec0047;
        }
      }
    }
  }
  .user-icon {
    position: absolute;
    bottom: -10px;
    right: 13px;
    cursor: pointer;
    span {
      width: 32px;
      height: 32px;
      border-radius: 50%;
      display: inline-block;
      transition: 0.3s;
      img {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
      }
    }
    & > .myinfo-list {
      position: absolute;
      right: 0;
      top:  35px;
      z-index: 20;
      width: 220px;
      height: auto;
      border-radius: 14px;
      box-shadow: 0 16px 15px -4px rgba(0, 0, 0, 0.12), 0 0 0 1px rgba(0, 0, 0, 0.16);
      background: #fff;
      box-sizing: border-box;
      padding: 20px;
      display: none;
      cursor: default;
      transition: 0.3s;
      li {
        font-size: 13px;
        font-weight: 500;
        color: #3096a7;
        cursor: pointer;
        &:nth-child(2) {
          font-size: 14px;
          color: #2f2f2f;
          font-weight: normal;
          margin-top: 40px;
        }
        &:last-child {
          width: 100%;
          margin-top: 40px;
        }
      }
    }
    &:hover {
      span {
        background: rgba(0, 0, 0, 0.06);
      }
      & > .myinfo-list {
        display: block;
      }
    }
  }
}

@media all and (max-width: 768px) {
  header {
    position: relative;
    height: 55px;
    top: 0;
    left: 0;
    &>a {
      bottom: auto;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .user-info {
    bottom: auto !important;
    left: 170px !important;
    top: 50%;
    transform: translateY(-50%);
    &::after {
      display: none;
    }
  }
  .user-icon {
    bottom: auto;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
